import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["customReasonGroup", "customReason"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.element.querySelector("input[type='radio']:checked")
    const isOther = selected && selected.dataset.other === "true"

    this.customReasonGroupTarget.style.display = isOther ? "block" : "none"

    if (isOther) {
      this.customReasonTarget.required = true
    } else {
      this.customReasonTarget.required = false
      this.customReasonTarget.value = ""
    }
  }
}
